import { useQueries } from 'react-query';
import { AppConfig } from '@oh-vcp/components-common';
import { apiGet } from './apiService';

const useSmartOnFhirResourcesByIds = (ids: string[]) => {
  return useQueries(
    ids.map((id) => ({
      queryKey: ['fhir-resource', id],
      queryFn: () => apiGet(`${AppConfig.baseSofLaunchUrl}/fhir/${id}`),
      enabled: !!id,
      refetchOnWindowFocus: false,
      retry: 0
    }))
  );
};

export default useSmartOnFhirResourcesByIds;
